import React from 'react';

/**
 * ProfileEdit - 信息编辑表单组件
 */
export function ProfileEdit({ 
  editData, 
  feedback, 
  isSaving, 
  onEditChange, 
  onSubmit, 
  onReset 
}) {
  return (
    <div className="edit-profile">
      <h2 className="profile-title">修改信息</h2>
      
      {feedback.message && (
        <div className={`profile-feedback ${feedback.type === 'error' ? 'is-error' : 'is-success'}`}>
          {feedback.message}
        </div>
      )}
      
      <form onSubmit={onSubmit} className="edit-form">
        {/* 个人信息 */}
        <div className="form-group-profile">
          <label className="form-label-profile">
            <span className="required">*</span> 真实姓名：
          </label>
          <input
            type="text"
            name="realName"
            value={editData.realName}
            onChange={onEditChange}
            className="form-input-profile"
            required
          />
        </div>

        <div className="form-group-profile">
          <label className="form-label-profile">
            <span className="required">*</span> 职位：
          </label>
          <input
            type="text"
            name="position"
            value={editData.position}
            onChange={onEditChange}
            className="form-input-profile"
            required
          />
        </div>

        <div className="form-group-profile">
          <label className="form-label-profile">企业名称：</label>
          <input
            type="text"
            name="company"
            value={editData.company}
            onChange={onEditChange}
            className="form-input-profile"
          />
        </div>

        <div className="form-group-profile">
          <label className="form-label-profile">邮箱：</label>
          <input
            type="email"
            name="email"
            value={editData.email}
            onChange={onEditChange}
            className="form-input-profile"
          />
        </div>

        {/* 分割线 */}
        <div className="divider" aria-hidden="true"></div>

        {/* 修改密码 */}
        <div className="form-group-profile">
          <label className="form-label-profile">旧密码：</label>
          <input
            type="password"
            name="oldPassword"
            value={editData.oldPassword}
            onChange={onEditChange}
            className="form-input-profile"
            placeholder="如需修改密码，请填写旧密码"
          />
        </div>

        <div className="form-group-profile">
          <label className="form-label-profile">新密码：</label>
          <input
            type="password"
            name="newPassword"
            value={editData.newPassword}
            onChange={onEditChange}
            className="form-input-profile"
            placeholder="至少6位，包含字母和数字"
          />
        </div>

        <div className="form-group-profile">
          <label className="form-label-profile">确认新密码：</label>
          <input
            type="password"
            name="confirmPassword"
            value={editData.confirmPassword}
            onChange={onEditChange}
            className="form-input-profile"
            placeholder="再次输入新密码"
          />
        </div>

        {/* 表单操作 */}
        <div className="form-actions-profile">
          <button 
            type="submit" 
            className="btn-submit-profile" 
            disabled={isSaving}
          >
            {isSaving ? '保存中...' : '确定'}
          </button>
          <button 
            type="button" 
            className="btn-reset-profile"
            onClick={onReset}
            disabled={isSaving}
          >
            重置
          </button>
        </div>
      </form>
    </div>
  );
}

